export const generateRandomString = (length: number) => {
    // Avoid using URL reserved characters
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890_-'; //which characters to use
    let result = '';
    for (let i = 0; i < length; i++) result += charset[Math.floor(Math.random() * charset.length)];

    return result;
};
